import setCompareItems from './set-compare-items.js';

/**
 * Reset compare tool - clears all items from comparison
 */
export default async function resetCompare() {
  return setCompareItems({ items: [] });
}
